export default function getTimeProfileRestEndpoint(commandName: string) {
    const restPath = 'api/beta/me/calendar/';

    return `${restPath}${commandName}`;
}
